if (!customElements.get('conditional-formsection')) {
  customElements.define('conditional-formsection',
    class FormComponent extends HTMLElement {
      constructor() {
        super();
        const displayRuleDefinition = this.dataset.displayRule;
        this.formIdentifier = this.closest("form").dataset.formIdentifier;
        this.listenerId = displayRuleDefinition.split("|")[0];
        this.listenerValue = displayRuleDefinition.split("|")[1];
        this.listenerFieldSelector = `[name="${this.listenerId}"]`;
        this.listenerFields = this.closest("form").querySelectorAll(this.listenerFieldSelector);
        this.formElements = ["input", "select", "textarea"];
      }
      
      connectedCallback() {
        this.setEventListener();
        this.checkInitialValue(this.closest("form").querySelector(`[id="${this.formIdentifier}-${this.listenerId}-${this.listenerValue}"]`));
        this.addEventListener('form:clear', () => {
          this.clear();
        });
      }

      setEventListener() {
        this.listenerFields.forEach((field) => {
          field.addEventListener("change", (e) => {
            this.checkListenerValue(e.target);
          });
        });
      }

      checkInitialValue(target) {
        const value = target.value.split("|")[1];
        if (target?.checked && value === this.listenerValue) {
          this.show();
        } else {
          this.hide();
        }
      }

      checkListenerValue(target) {
        console.log(target);
        this.hide();
        const value = target.value.split("|")[1];
        if (target.id === `${this.formIdentifier}-${this.listenerId}-${this.listenerValue}` && target.checked && value === this.listenerValue) {
          this.show();
        }
      }

      show() {
        this.style.display = "";
        this.formElements.forEach((formElementName) => {
          this.querySelectorAll(formElementName).forEach((formElement) => {
            formElement.removeAttribute("disabled");
          });
        });
      }

      hide() {
        this.style.display = "none";
        this.formElements.forEach((formElementName) => {
          this.querySelectorAll(formElementName).forEach((formElement) => {
            formElement.setAttribute("disabled", "");
          });
        });
      }

      clear() {
        this.checkInitialValue(this.closest("form").querySelector(`[id="${this.formIdentifier}-${this.listenerId}-${this.listenerValue}"]`));
      }
    }
  );
}
